export default __webpack_public_path__ + "static/media/DSC_0333.36db1da9.jpg";